import { GridPagination } from '@mui/x-data-grid'

// this customization has needed due to the behavior (scroll up) inside the Static's iframe
export function CustomGridPagination(props) {
  return (
    <GridPagination
      {...props}
      SelectProps={{
        MenuProps: {
          autoFocus: false,
          disableAutoFocus: true,
          disableAutoFocusItem: true,
          disableEnforceFocus: true,
        },
      }}
    />
  )
}
